import { render, staticRenderFns } from "./AnLiDetail.vue?vue&type=template&id=1cda3af8&scoped=true"
import script from "./AnLiDetail.vue?vue&type=script&lang=js"
export * from "./AnLiDetail.vue?vue&type=script&lang=js"
import style0 from "./AnLiDetail.vue?vue&type=style&index=0&id=1cda3af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cda3af8",
  null
  
)

export default component.exports